function isBrowser() {
  return typeof window !== "undefined";
}

function getEnv() {
  if (isBrowser()) {
    return window?.ENV || {};
  }
  return process.env || {};
}

export default getEnv;
